<template>
  <DialogContent class="flex flex-col items-center text-center">
    <DacrBadge class="size-10" :icon-size="28" />

    <div
      class="font-semibold font-primary text-[34px] leading-[40px] tablet-h:leading-[50px] text-gray-800 mb-[14px]"
    >
      Welcome to Dacr Pro!
    </div>
    <div
      class="font-secondary text-[16px] leading-[24px] text-gray-500 mb-[26px]"
    >
      You've unlocked powerful tools for your copyrighted work with no limits.
    </div>
    <Lottie name="Infinite-Files" class="min-w-[1875px]" loop />
  </DialogContent>
  <DialogFooter class="justify-center!">
    <UiButton class="w-full! tablet-h:w-auto!" primary large @click="close()">
      Get started
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import Lottie from '@/shared/components/Lottie.vue'
import DacrBadge from '@/shared/components/DacrBadge.vue'

const { close } = useDialog()
</script>
